import { UserCertificate } from './models/certificate.model';
import { UserSession } from './models/session.model';
import { certificateReducer } from './reducers/certificate.reducer';
import { sessionReducer } from './reducers/session.reducer.';

const State = {
  session: sessionReducer,
  certificate: certificateReducer,
};

export interface GlobalState {
  session: UserSession;
  certificate: UserCertificate;
}

export default State;

export const intialStore: Partial<GlobalState> = {
  certificate: undefined,
  session: undefined,
};
